import $ from 'jquery';
import nextButtonUrl from '@/images/nextbutton.png';
import disabledNextUrl from '@/images/disablednext.png';
import widgetStartoverButtonUrl from '@/images/widget_startover_button.gif';

var screen_num = 1;
var id1 = '';
var id2 = '';
let fuel_type_display;

function get_fuel_type_param() {
  var url = window.location.pathname;
  var vars = url.split('/');
  if (vars.length > 3) return vars[3];
  else return '';
}

function get_button_param() {
  var url = window.location.pathname;
  var vars = url.split('/');
  if (vars.length > 4 && vars[4] == 'y') return true;
  else return false;
}

window.turn_on_next = function(sel) {
  if (sel.value != "") {
    $('#next_div').css( 'cursor', 'pointer' );
    $('#next_img').attr('src', nextButtonUrl);
  } else {
    $('#next_div').css( 'cursor', 'default' );
    $('#next_img').attr('src', disabledNextUrl);
  }
}

function reset_screen1() {
  $('#screen_1').show();
  $('#screen_5').hide();
  $('#tech_select').find('option:first').attr('selected','selected');
  $('#next_div').css( 'cursor', 'default' );
  $('#next_img').attr('src', disabledNextUrl);
  $('#back_next_buttons .next_button').attr('src', nextButtonUrl);
  $('.top_text').html('Choose a vehicle to compare fuel cost and emissions with a conventional vehicle.');
  $('#back_next_buttons').hide();
  screen_num = 1;
}

function back_button_toggle(which) {
  if (which == 'on') {
    $('#back_button_div').show();
    $('#next_button_div').css('width', '50%');
  } else {
    $('#back_button_div').hide();
    $('#next_button_div').css('width', '100%');
  }
}

function setup_screen_2() {
  $('#vehicle_type_display').text(fuel_type_display);
  $('.top_text').html('Enter mileage to compare cost and emissions.');
  if (get_fuel_type_param() && get_fuel_type_param() != 'Electric') {
    back_button_toggle('off');
  }
  $('#screen_2').show();
  $('#screen_1').hide();
  $('#back_next_buttons .next_button').attr('src', nextButtonUrl);
  $('#back_next_buttons').show();
  if (fuel_type_display == 'Hybrid') {
    id1=33374;
    id2=33372;
  }
  if (fuel_type_display == 'Plug-in Hybrid') {
    $('#plugin_hybrid_fuel_economy').show();
    id1 = 33335;
    id2 = 33324;
  }
  if (fuel_type_display == 'Natural Gas') {
    $('.alt_fuel_units_display').html('(mi/GGE)');
    id1 = 33503;
    id2 = 33504;
  }
  if (fuel_type_display == 'LPG' || fuel_type_display == 'Propane') {
    $('.alt_fuel_units_display').html('(mi/GGE)');
    id1 = 35037;
    id2 = 35037;
  }
  if (fuel_type_display == 'Biodiesel') {
    $('.alt_fuel_units_display').html('(mi/gal of B20)');
    $('.control_fuel_economy_units').html('(mi/gal of diesel)');
    $('#control_title').html('Diesel');
    id1 = 32716;
    id2 = 32613;
  }
  if (fuel_type_display == 'Electric') {
    $('.alt_fuel_units_display').html('(kWh/100mi)');
    id1 = 33558;
    id2 = 33266;
  }
  if (fuel_type_display == 'Flex Fuel') {
    $('.alt_fuel_units_display').html('(mi/gal of E85)');
    id1 = 32919;
    id2 = 32916;
  }
  screen_num = 2;
  let type_display;
  if (fuel_type_display == 'Propane') type_display = 'LPG';
  else type_display = fuel_type_display;
  ajax_request("?test=y&ft="+type_display+"&screen="+screen_num+"&id1="+id1+"&id2="+id2)
}

function setup_screen_3() {
  $('.top_text').html('Enter your driving habits.');
  $('#screen_3').show();
  $('#screen_2').hide();
  back_button_toggle('on');
  $('#back_next_buttons').show();
  screen_num = 3;
}

function setup_screen_4() {
  $('.top_text').hide();
  $('#screen_4').show();
  $('#screen_3').hide();
  $('#back_next_buttons').show();
  screen_num = 4;
  let type_display;
  if (fuel_type_display == 'Propane') type_display = 'LPG';
  else type_display = fuel_type_display;
  var parms = '?ft='+type_display+'&screen='+screen_num+'&id1='+id1+'&id2='+id2;
  parms = parms + '&daily_miles='+$('#daily_miles').val();
  parms = parms + '&other_miles='+$('#other_miles').val();
  parms = parms + `&dpc=${parseInt(document.getElementById('daily_percent_hwy_display_city').textContent, 10)}`;
  parms = parms + `&dph=${parseInt(document.getElementById('daily_percent_hwy_display_hwy').textContent, 10)}`;
  parms = parms + `&opc=${parseInt(document.getElementById('other_percent_hwy_display_city').textContent, 10)}`;
  parms = parms + `&oph=${parseInt(document.getElementById('other_percent_hwy_display_hwy').textContent, 10)}`;
  parms = parms + '&alt_city='+$('#alt_city').val();
  parms = parms + '&alt_hwy='+$('#alt_hwy').val();
  parms = parms + '&elec_city='+$('#elec_city').val();
  parms = parms + '&elec_hwy='+$('#elec_hwy').val();
  parms = parms + '&city='+$('#city').val();
  parms = parms + '&hwy='+$('#hwy').val();
  ajax_request(parms)
}

function setup_screen_5() {
  $('.top_text').html('To compare specific models<br />and operating costs,<br />go to the AFDC&#39;s<br /><a href="/calc/" target="_parent">Vehicle Cost Calculator</a>');
  $('.top_text').show();
  $('#screen_5').show();
  $('#screen_4').hide();
  $('#back_next_buttons .next_button').attr('src', widgetStartoverButtonUrl);
  $('#back_next_buttons').show();
  screen_num = 5;
}

$(document).ready(function() {
  fuel_type_display = get_fuel_type_param();

  if (get_button_param()) {
    $('#widget_link').hide();
  }

  if (fuel_type_display != 'Electric' && fuel_type_display != '') {
    fuel_type_display = decodeURIComponent(fuel_type_display);
    $('#fuel_type_title').text(fuel_type_display);
    setup_screen_2();
  }

  if (get_fuel_type_param() == 'Electric') {
    $('#fuel_type_title').html('Electric Drive');
    $('#tech_select option').each(function() {
      if ($(this).val() == 'Natural Gas' || $(this).val() == 'Flex Fuel' || $(this).val() == 'Biodiesel' || $(this).val() == 'LPG' || $(this).val() == 'Propane') {
        $(this).remove();
      }
    });
  }
  $('#next_img').click(function() {
    $('#plugin_hybrid_fuel_economy').hide();
    if (screen_num == 1 && $(this).attr('src') == nextButtonUrl) {
      fuel_type_display = $('#tech_select').val();
      setup_screen_2();
    }
  });
  $('.next_button').click(function() {
    var cur_screen = screen_num;
    if (cur_screen == 2) {
      setup_screen_3();
    }
    if (cur_screen == 5) {
      $('#screen_5').hide();
      $('#back_next_buttons .next_button').attr('src', widgetStartoverButtonUrl);
     if (get_fuel_type_param() != '' && get_fuel_type_param() != 'Electric') {
        $('#fuel_type_title').text(fuel_type_display);
        setup_screen_2();
      } else reset_screen1();
    }
    if (cur_screen == 4) {
      setup_screen_5(fuel_type_display);
    }
    if (cur_screen == 3) {
      setup_screen_4();
    }
  });
  $('.back_button').click(function() {
    if (screen_num == 2) {
      $('.top_text').html('Choose a vehicle to compare fuel cost and emissions with a conventional vehicle.');
      $('#screen_1').show();
      $('#screen_2').hide();
      $('#back_next_buttons').hide();
      screen_num = 1;
    }
    if (screen_num == 3) {
      $('.top_text').html('Enter mileage to compare cost and emissions.');
      $('.top_text').show();
      if (get_fuel_type_param() != '') {
        back_button_toggle('off');
      }
      $('#screen_2').show();
      $('#screen_3').hide();
      screen_num = 2;
    }
    if (screen_num == 4) {
      $('.top_text').html('Enter your driving habits.');
      $('.top_text').show();
      $('#screen_3').show();
      $('#screen_4').hide();
      screen_num = 3;
    }
    if (screen_num == 5) {
      $('.top_text').hide();
      $('#screen_4').show();
      $('#back_next_buttons .next_button').attr('src', nextButtonUrl);
      $('#screen_5').hide();
      setup_screen_4();
      screen_num = 4;
    }
  });
  $('#youtube_tab').click(function(e) {
    e.preventDefault();
    $('#youtube_tab').addClass('active');
    $('#blog_tab').removeClass('active');
    $('#news_tab').removeClass('active');
    $('#youtube_list').show();
    $('#blog_list').hide();
    $('#news_list').hide();
  });
  $('#blog_tab').click(function(e) {
    e.preventDefault();
    $('#blog_tab').addClass('active');
    $('#youtube_tab').removeClass('active');
    $('#news_tab').removeClass('active');
    $('#youtube_list').hide();
    $('#blog_list').show();
    $('#news_list').hide();
  });
  $('#news_tab').click(function(e) {
    e.preventDefault();
    $('#news_tab').addClass('active');
    $('#blog_tab').removeClass('active');
    $('#youtube_tab').removeClass('active');
    $('#youtube_list').hide();
    $('#blog_list').hide();
    $('#news_list').show();
  });

  // Hook up the range sliders to show the city/hwy txt values next to them on
  // change.
  document.querySelectorAll('.city-hwy-slider input[type=range]').forEach((pctHwyEl) => {
    const pctHwyDisplayCityEl = document.getElementById(`${pctHwyEl.id}_display_city`);
    const pctHwyDisplayHwyEl = document.getElementById(`${pctHwyEl.id}_display_hwy`);
    pctHwyEl.addEventListener('input', () => {
      const pctHwy = parseInt(pctHwyEl.value, 10);
      const pctCity = 100 - pctHwy;
      pctHwyDisplayCityEl.textContent = `${pctCity}%`;
      pctHwyDisplayHwyEl.textContent = `${pctHwy}%`;
    });
    pctHwyEl.dispatchEvent(new Event('input'));
  });
});

function ajax_request(parms){
  var ajaxRequest;
  document.body.style.cursor = 'wait';

  try {
    // Opera 8.0+, Firefox, Safari
    ajaxRequest = new XMLHttpRequest();
  } catch (e) {
  // Internet Explorer Browsers
    try{
      // eslint-disable-next-line no-undef
      ajaxRequest = new ActiveXObject("Msxml2.XMLHTTP");
    } catch (e) {
      try{
        // eslint-disable-next-line no-undef
        ajaxRequest = new ActiveXObject("Microsoft.XMLHTTP");
      } catch (e) {
        // Something went wrong
        alert("Your browser broke!");
        return false;
      }
    }
  }
  ajaxRequest.onreadystatechange = function(){
    if(ajaxRequest.readyState == 4){
      eval(ajaxRequest.responseText);
      document.body.style.cursor = 'default';
    }
  }
  ajaxRequest.open("GET", "/ajax/calc_ajax.php"+parms, true);
  ajaxRequest.send(null);
}

window.google.charts.load('current', { packages: ['corechart'] });

window.drawChart = function(alt_fuel_display, emissions, alt_emissions, total_fuel_cost, total_alt_fuel_cost) {
  window.google.charts.setOnLoadCallback(function() {
    const control_title = $('#control_title').html();
    const data = new window.google.visualization.DataTable();
    data.addColumn('string', 'Fuel Type');
    data.addColumn('number', '$');
    data.addColumn('number', '$');
    data.addRows(2);
    data.setValue(0, 0, alt_fuel_display);
    data.setValue(0, 1, total_alt_fuel_cost);
    data.setValue(0, 2, 0);

    data.setValue(1, 0, control_title);
    data.setValue(1, 1, 0);
    data.setValue(1, 2, total_fuel_cost);

    const chart = new window.google.visualization.ColumnChart(document.getElementById('fuel_cost_graph'));
    chart.draw(data, {width: 250, height: 150, legend:'none',titlePosition:'none',
    vAxis: {baseline:0,format:'$#',baselineColor:'#000033',gridlineColor:'#ccc',
          textStyle: {color: 'black', fontName: 'Arial', fontSize: '12', fontWeight:'bold'}},
    hAxis: {baselineColor:'#333', textPosition:'none'},
    backgroundColor:'#eee', margin:'0', padding:0,
    chartArea: {left:60,top:20,width:"70%",height:"83%"},
    isStacked: true,  colors:['#c1d7bf','#b7d9f2']});

    const data2 = new window.google.visualization.DataTable();
    data2.addColumn('string', 'Fuel Type');
    data2.addColumn('number', 'lbs of CO2');
    data2.addColumn('number', 'lbs of CO2');
    data2.addRows(2);
    data2.setValue(0, 0, alt_fuel_display);
    data2.setValue(0, 1, alt_emissions);
    data2.setValue(0, 2, 0);

    data2.setValue(1, 0, control_title);
    data2.setValue(1, 1, 0);
    data2.setValue(1, 2, emissions);

    const chart2 = new window.google.visualization.ColumnChart(document.getElementById('emissions_graph'));
    chart2.draw(data2, {width: 250, height: 150, titlePosition:'none', legend:'none',
    vAxis: {baseline:0,format:'#',baselineColor:'#000033',gridlineColor:'#ccc',
          textStyle: {color: 'black', fontName: 'Arial', fontSize: '12', fontWeight:'bold'}},
    hAxis: {baselineColor:'#333', textPosition:'none'},
    backgroundColor:'#eee', margin:'0', padding:0,
    chartArea: {left:60,top:20,width:"70%",height:"83%"},
    isStacked: true,  colors:['#c1d7bf','#b7d9f2']});
    if ($('#fuel_cost_radio_button').is(':checked'))
      document.getElementById('emissions').style.display='none';
  });
}
